import { isNumberOnly } from './number';

export const checkValidCatalogProductId = (catalog_product_id: string) => {
  return isNumberOnly(catalog_product_id) && catalog_product_id !== '0';
};
